import ServerBaseError from './ServerBaseError';

export default class RequestRetryFailureError extends ServerBaseError {
  constructor(message = 'Retried request', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
